'use strict';
const qs = require('querystring');
const url = require('url');
const client = {
  https: require('https'),
  http: require('http'),
};

const REDIRECT_CODES = [301, 302, 303, 307];
class SimpleError extends Error {
  constructor() {
    super('Error happened due to simple constraint not being 2xx status code.');
    this.name = 'FR_Simple';
  }
}
class RequestError extends Error {
  constructor(e) {
    super('Error happened reguarding a request: ' + e.message);
    this.name = 'FR_Request_' + e.name;
  }
}

class RequestTimeoutError extends Error {
  constructor(e) {
    super('Error happened reguarding a request: ' + e.message);
    this.name = 'FR_Request_Timeout';
  }
}

class Fasquest {
  constructor() {
    this.agent = {
      http: new client.http.Agent({
        keepAlive: true,
      }),
      https: new client.https.Agent({
        keepAlive: true,
      }),
    };
  }
  request(options, cb = null) {
    if (!cb) {
      return this.requestPromise(options);
    } else {
      this._request(options, (req, res, err) => {
        cb({
          req,
          res,
          err,
        });
      });
    }
  }
  requestPromise(options) {
    return new Promise((resolve, reject) => {
      this._request(options, (req, res, err) => {
        if (err) {
          reject({
            req,
            res,
            err,
          });
        } else {
          resolve(options.resolveWithFullResponse ? res : res.body);
        }
      });
    });
  }
  _request(ops, cb, count = 0) {
    var options = this._setOptions(ops);

    var req = client[options.proto].request(options, (res) => {
      res.body = '';

      res.on('data', (chunk) => {
        res.body += chunk;
      });

      res.on('end', () => {
        if (options.timeout) {
          clearTimeout(t);
        }
        // remove as causes circular references

        if (
          REDIRECT_CODES.indexOf(res.statusCode) !== -1 &&
          count < options.redirect_max
        ) {
          options.uri = url.resolve(options.uri, res.headers.location);
          return this._request(this._setOptions(options), cb, ++count);
        } else {
          if (
            res.headers['content-type'] &&
            res.headers['content-type'].indexOf('json') > -1
          ) {
            try {
              res.body = JSON.parse(res.body);
            } catch (e) {
              // do nothing
            }
          }
          if (options.simple) {
            if (res.statusCode > 299 || res.statusCode < 200) {
              return cb(req, res, new SimpleError());
            }
          }
          return cb(req, res, null);
        }
      });
    });

    if (options.timeout) {
      var t = setTimeout(() => {
        req.destroy();
      }, options.timeout || 60000);
    }

    req.on('error', (e) => {
      var err =
        e.message.indexOf('socket hang up') > -1
          ? new RequestTimeoutError(e)
          : new RequestError(e);

      return cb(req, null, err);
    });

    if (options.body) {
      req.write(options.body);
    }
    req.end();
  }
  _setOptions(opts) {
    var options = {};

    options.simple = opts.simple !== false;
    options.method = opts.method || 'GET';
    options.uri = opts.uri;
    options.timeout = opts.timeout;

    if (opts.qs) {
      var escQS = qs.stringify(opts.qs);

      if (escQS.length > 0) {
        options.uri += (options.uri.indexOf('?') > -1 ? '&' : '?') + escQS;
      }
    }
    options = this._uri_to_options(options.uri, options);
    options.agent = opts.agent || this.agent[opts.proto];
    options.headers = {};
    if (opts.headers) {
      var h = Object.keys(opts.headers);

      for (var i = 0; i < h.length; i++) {
        options.headers[h[i]] = opts.headers[h[i]];
      }
    }
    if (opts.json) {
      options.headers['Content-Type'] = 'application/json';
      if (opts.body) {
        options.body = JSON.stringify(opts.body);
      }
    } else if (opts.form) {
      options.body = qs.stringify(opts.form);

      options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      options.headers['Content-Length'] = Buffer.byteLength(options.body);
    } else if (opts.body) {
      options.headers['Content-Length'] = Buffer.byteLength(opts.body);
      if (!options.headers['Content-Type']) {
        options.headers['Content-Type'] = 'text/plain';
      }
      options.body = opts.body;
    }
    if (opts.authorization) {
      if (opts.authorization.basic) {
        options.headers['Authorization'] =
          'Basic ' +
          Buffer.from(
            opts.authorization.basic.client +
              ':' +
              opts.authorization.basic.secret,
            'ascii'
          ).toString('base64');
      } else if (opts.authorization.bearer) {
        options.headers['Authorization'] =
          'Bearer ' + opts.authorization.bearer;
      }
    }
    if (!opts.redirect_max && opts.redirect_max !== 0) {
      options.redirect_max = 5;
    }

    return options;
  }
  _uri_to_options(uri, options) {
    var convertedUri = {
      proto: '',
      path: '',
      port: 80,
      host: '',
    };
    var splitURI = uri.split('://');

    convertedUri.proto = splitURI[0];
    var possiblePort = splitURI[1].indexOf(':');

    if (possiblePort > -1 && !isNaN(splitURI[1][possiblePort + 1])) {
      const pindex = splitURI[1].indexOf('/');

      if (pindex > -1) {
        convertedUri.path = splitURI[1].slice(pindex);
        convertedUri.port = splitURI[1].slice(possiblePort + 1, pindex);
      } else {
        convertedUri.port = splitURI[1].slice(possiblePort + 1);
      }
      convertedUri.host = splitURI[1].slice(0, possiblePort);
    } else {
      convertedUri.port = convertedUri.proto == 'https' ? 443 : 80;
    }
    const hostIndex = splitURI[1].indexOf('/');

    if (hostIndex > -1) {
      convertedUri.path = convertedUri.path || splitURI[1].slice(hostIndex);
      convertedUri.host = convertedUri.host || splitURI[1].slice(0, hostIndex);
    } else {
      convertedUri.path = convertedUri.path || '/';
      convertedUri.host = convertedUri.host || splitURI[1];
    }
    options.proto = convertedUri.proto;
    options.path = convertedUri.path;
    options.port = convertedUri.port;
    options.host = convertedUri.host;
    return options;
  }
}
module.exports = new Fasquest();

/**
 * SDK - importing the SDK for use
 * @param {string} host the hostname to the service (example: http://127.0.0.1)
 * @param {object} opts options that will be appened to every request. [Fasquest Lib Options](https://github.com/Phara0h/Fasquest) (example: {headers: {'API-KEY':'34098hodf'}})
 * @example
 * init
 * ```js
 * const { BillingProcessor } = require('./sdk.js')('http://127.0.0.1');
 * ```
 */
function SDK(host, opts) {
  var hostUrl = '';
  var defaultOpts = null;

  if (host) {
    hostUrl = host;
  }
  if (opts) {
    defaultOpts = opts;
  }
  const fasq = new Fasquest();

  /**
   *
   */
  class BillingProcessor {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        healthcheck: 'billing-processor/health',
        metrics: 'billing-processor/metrics',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * healthCheck - Placeholder new request
     *
     * Path: billing-processor/health
     */
    static async healthCheck(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/health`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * metrics -
     *
     * Path: billing-processor/metrics
     */
    static async metrics(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/metrics`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get Transcripts() {
      return Transcripts;
    }

    static get Checkoutdotcom() {
      return Checkoutdotcom;
    }

    static get Vgs() {
      return Vgs;
    }

    static get Paypal() {
      return Paypal;
    }

    static get Process() {
      return Process;
    }

    static get Payment() {
      return Payment;
    }

    static get Gateway() {
      return Gateway;
    }

    static get Blocked() {
      return Blocked;
    }
  }
  /**
   *
   */
  class Transcripts {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        countlist: 'billing-processor/v1/transcripts/domain/:domain/list/count',
        list: 'billing-processor/v1/transcripts/domain/:domain/list',
        byid: 'billing-processor/v1/transcripts/domain/:domain/id/:id',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * countList -
     *
     * Path: billing-processor/v1/transcripts/domain/:domain/list/count
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} params  (example: payment_id=cff8226c-e950-4662-8054-d860de8d75e3)
     * @param {any} skip  (example: 2)
     */
    static async countList(domain, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/transcripts/domain/${domain}/list/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * list -
     *
     * Path: billing-processor/v1/transcripts/domain/:domain/list
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} limit  (example: 1)
     * @param {any} props
     * @param {any} skip  (example: 2)
     * @param {any} params  (example: payment_id=cff8226c-e950-4662-8054-d860de8d75e3)
     * @param {any} sort
     * @param {any} sortDesc
     */
    static async list(
      domain,
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/transcripts/domain/${domain}/list`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId -
     *
     * Path: billing-processor/v1/transcripts/domain/:domain/id/:id
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} id  (example: 34ec488e-0cd1-430c-bf6a-ae624caea710)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/transcripts/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Checkoutdotcom {
    constructor() {}
    static get _postgenClassUrls() {
      return { authorizepayment: 'payments' };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * authorizePayment -
     *
     * Path: payments
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *   "source": {
     *     "type": "card",
     *     "number": "4024007181869214",
     *     "expiry_month": 12,
     *     "expiry_year": 2025
     *   },
     *   "amount": 6540,
     *   "currency": "USD",
     *   "payment_type": "Recurring",
     *   "reference": "ORD-5023-4E89",
     *   "description": "Set of 3 masks",
     *   "capture": true,
     *   "capture_on": "2019-09-10T10:11:12Z",
     *   "customer": {
     *     "id": "cus_udst2tfldj6upmye2reztkmm4i",
     *     "email": "johnsmith@example.com",
     *     "name": "John Smith",
     *     "phone": {
     *       "country_code": "+1",
     *       "number": "415 555 2671"
     *     }
     *   },
     *   "billing_descriptor": {
     *     "name": "Withdrawal",
     *     "city": "London"
     *   },
     *   "shipping": {
     *     "address": {
     *       "address_line1": "Checkout.com",
     *       "address_line2": "Flat 456",
     *       "city": "London",
     *       "state": "GB",
     *       "zip": "SW1A 1AA",
     *       "country": "GB"
     *     },
     *     "phone": {
     *       "country_code": "+1",
     *       "number": "415 555 2671"
     *     }
     *   },
     *   "3ds": {
     *     "enabled": false,
     *     "attempt_n3d": false,
     *     "eci": "05",
     *     "cryptogram": "AgAAAAAAAIR8CQrXcIhbQAAAAAA=",
     *     "xid": "MDAwMDAwMDAwMDAwMDAwMzIyNzY=",
     *     "version": "2.0.1"
     *   },
     *   "previous_payment_id": "pay_fun26akvvjjerahhctaq2uzhu4",
     *   "risk": {
     *     "enabled": false
     *   },
     *   "success_url": "https://example.com/payments/success",
     *   "failure_url": "https://example.com/payments/fail",
     *   "payment_ip": "90.197.169.245",
     *   "recipient": {
     *     "dob": "1985-05-15",
     *     "account_number": "5555554444",
     *     "zip": "SW1A",
     *     "last_name": "Jones"
     *   },
     *   "metadata": {
     *     "coupon_code": "NY2018",
     *     "partner_id": 123989
     *   },
     *   "segment": {
     *     "brand": "Acme Corporation",
     *     "business_category": "Inward Payment",
     *     "market": "UK"
     *   }
     * }
     * ```
     */
    static async authorizePayment(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `payments`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Vgs {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        cardcheck: 'card-check',
        vgscollect: 'vgs/connect',
        tokenize: 'post',
        requestbearertoken: 'auth/realms/vgs/protocol/openid-connect/token',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * cardCheck -
     *
     * Path: card-check
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *     "name": "John Doe",
     *     "number": "4327390068355738",
     *     "exp_month": 10,
     *     "exp_year": 22
     * }
     * ```
     */
    static async cardCheck(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `card-check`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * vgsCollect - 
  *
  * Path: vgs/connect
  * @param {any} props Optional: Model's properties to be returned with each onject. 
(example: name,enabled, will return objects with the following structure:
{
"name": "test block for getting",
"enabled": true
} (example: month,year)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, current_money = 0) (example: current_transactions=1234, current_money = 50)
  * @param {any} sort Optional. Column name to sort Caps (example: current_money)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async vgsCollect(props, skip, params, sort, sortDesc, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `vgs/connect`,
        qs: { props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * tokenize -
     *
     * Path: post
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *     "card_number":"4111111111111111",
     *     "card_cvc": "123",
     *     "firstname": "Big",
     *     "lastname": "John",
     *     "email":"bigjohn@yolo420.com",
     *     "zipcode":"32817",
     *     "exp_month":"05",
     *     "exp_year":"29"
     * }
     * ```
     */
    static async tokenize(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `post`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * requestBearerToken -
     *
     * Path: auth/realms/vgs/protocol/openid-connect/token
     */
    static async requestBearerToken(grant_type, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `auth/realms/vgs/protocol/openid-connect/token`,
        form: {
          grant_type,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get Networktokens() {
      return VgsNetworktokens;
    }
  }
  /**
   *
   */
  class VgsNetworktokens {
    constructor() {}
    static get _postgenClassUrls() {
      return { requestnetworktoken: 'network-tokens' };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * requestNetworkToken -
     *
     * Path: network-tokens
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *   "name": "John Doe",
     * "pan": "5573495XKjDP28V7312",
     *   "exp_month": 7,
     *   "exp_year": 24
     * }
     *
     *
     * ```
     */
    static async requestNetworkToken(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `network-tokens`,
        body,
        json: true,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Paypal {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        getorderdetails: 'v2/checkout/orders/:order_id',
        void: 'v2/payments/authorizations/:authorization_id/void',
        refund: 'v2/payments/captures/:order_id/refund',
        confirmpaymentsource:
          'v2/checkout/orders/:order_id/confirm-payment-source',
        setuppaymenttoken: 'v3/vault/setup-tokens',
        createorder: 'v2/checkout/orders',
        authorizepayment: 'v2/checkout/orders/:order_id/authorize',
        captureauthorizedpayment:
          'v2/payments/authorizations/:authorization_id/capture',
        reauthorize: 'v2/payments/authorizations/:authorization_id/reauthorize',
        purchase: 'v2/payments/captures/:order_id',
        billingplanactivate: 'v1/payments/billing-plans/:plan_id',
        billingplan: 'v1/payments/billing-plans',
        billingagreementexecute: 'v1/payments/billing-agreements',
        billingagreementget: 'v1/payments/billing-agreements/:agreement_id',
        billingagreementtoken: 'v1/billing-agreements/agreement-tokens',
        createbillingagreement: 'v1/billing-agreements/agreements',
        capture: 'v2/checkout/orders/:order_id/capture',
        requestbearertoken: 'v1/oauth2/token',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * getOrderDetails -
     *
     * Path: v2/checkout/orders/:order_id
     * @param {any} order_id  (example: 27618054GN899282B)
     */
    static async getOrderDetails(order_id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `v2/checkout/orders/${order_id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * void -
     *
     * Path: v2/payments/authorizations/:authorization_id/void
     * @param {any} authorization_id  (example: 36L32879VV202090N)
     */
    static async void(authorization_id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl + '/' + `v2/payments/authorizations/${authorization_id}/void`,
        form: {},
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * refund -
     *
     * Path: v2/payments/captures/:order_id/refund
     * @param {Object} body
     * @param {any} order_id
     * @example
     * body
     * ```json
     * {
     *     "amount": {
     *         "value": "19.00",
     *         "currency_code": "USD"
     *     },
     *     "invoice_id": "9WK599677R272420W",
     *     "note_to_payer": "DefectiveProduct"
     * }
     * ```
     */
    static async refund(body, order_id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v2/payments/captures/${order_id}/refund`,
        body,
        json: true,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * confirmPaymentSource -
     *
     * Path: v2/checkout/orders/:order_id/confirm-payment-source
     * @param {Object} body
     * @param {any} order_id  (example: 0RJ72211XT296945V)
     * @example
     * body
     * ```json
     * {
     *     "intent": "AUTHORIZE",
     *     "purchase_units": [
     *         {
     *             "reference_id": "20001",
     *             "amount": {
     *                 "currency_code": "USD",
     *                 "value": "1.00"
     *             }
     *         }
     *     ],
     *     "payment_source": {
     *         "paypal": {
     *             "experience_context": {
     *                 "payment_method_preference": "UNRESTRICTED",
     *
     *                 "locale": "en-US",
     *                 "landing_page": "LOGIN",
     *                 "user_action": "CONTINUE",
     *                 "return_url": "https://127.0.0.1/returnUrl",
     *                 "cancel_url": ""
     *             }
     *         }
     *     }
     * }
     * ```
     */
    static async confirmPaymentSource(body, order_id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `v2/checkout/orders/${order_id}/confirm-payment-source`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * setUpPaymentToken -
     *
     * Path: v3/vault/setup-tokens
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *     "customer": {
     *       //  "id": "customer_30243625",
     *         "merchant_customer_id": "azothhermes@hotmail.com"
     *     },
     *     "payment_source": {
     *         "paypal": {
     *             "description": "Description for PayPal to be shown to PayPal payer",
     *             "shipping": {
     *                 "name": {
     *                     "full_name": "Firstname Lastname"
     *                 },
     *                 "address": {
     *                     "address_line_1": "2211 N First Street",
     *                     "address_line_2": "Building 17",
     *                     "admin_area_2": "San Jose",
     *                     "admin_area_1": "CA",
     *                     "postal_code": "95131",
     *                     "country_code": "US"
     *                 }
     *             },
     *             "permit_multiple_payment_tokens": false,
     *             "usage_pattern": "IMMEDIATE",
     *            // "usage_type": "PLATFORM",
     *             "customer_type": "CONSUMER",
     *             "experience_context": {
     *                // "shipping_preference": "SET_PROVIDED_ADDRESS",
     *                 "payment_method_preference": "IMMEDIATE_PAYMENT_REQUIRED",
     *               //  "brand_name": "EXAMPLE INC",
     *                 "locale": "en-US",
     *                 "return_url": "https://127.0.0.1/returnUrl",
     *                 "cancel_url": "https://127.0.0.1/returnUrl"
     *             }
     *         }
     *     }
     * }
     * ```
     */
    static async setUpPaymentToken(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v3/vault/setup-tokens`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * createOrder -
     *
     * Path: v2/checkout/orders
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *     "intent": "AUTHORIZE",
     *     "purchase_units": [
     *         {
     *             "reference_id": "z0000001-1234-abcd-89ff-12ab04a15c43zipxx",
     *             "amount": {
     *                 "currency_code": "USD",
     *                 "value": 2
     *             }
     *         }
     *     ],
     *     "payment_source": {
     *         "token": {
     *             "id": "B-9414548068022805B",
     *             "type": "BILLING_AGREEMENT"
     *         }
     *     }
     * }
     * ```
     */
    static async createOrder(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v2/checkout/orders`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * authorizePayment -
     *
     * Path: v2/checkout/orders/:order_id/authorize
     * @param {Object} body
     * @param {any} order_id  (example: 4SC33658SU914301D)
     * @example
     * body
     * ```json
     * {
     *     "intent": "AUTHORIZE",
     *     "purchase_units": [
     *         {
     *             "reference_id": "20000000000011",
     *             "amount": {
     *                 "currency_code": "USD",
     *                 "value": "100.00"
     *             }
     *         }
     *     ]}
     * ```
     */
    static async authorizePayment(body, order_id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v2/checkout/orders/${order_id}/authorize`,
        body,
        json: true,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * captureAuthorizedPayment -
     *
     * Path: v2/payments/authorizations/:authorization_id/capture
     * @param {Object} body
     * @param {any} authorization_id
     * @example
     * body
     * ```json
     * {
     *     "amount": {
     *         "value": "10.99",
     *         "currency_code": "USD"
     *     },
     *     "invoice_id": "INVOICE-123",
     *     "final_capture": true,
     *     "note_to_payer": "Enjoy.",
     *     "soft_descriptor": "Happy finger monkey"
     * }
     * ```
     */
    static async captureAuthorizedPayment(body, authorization_id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `v2/payments/authorizations/${authorization_id}/capture`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * reauthorize -
     *
     * Path: v2/payments/authorizations/:authorization_id/reauthorize
     * @param {Object} body
     * @param {any} authorization_id  (example: 7WJ20791B1522892E)
     * @example
     * body
     * ```json
     * {
     *     "amount": {
     *         "value": "10.99",
     *         "currency_code": "USD"
     *     }
     * })
     * ```
     */
    static async reauthorize(body, authorization_id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `v2/payments/authorizations/${authorization_id}/reauthorize`,
        body,
        json: true,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * purchase -
     *
     * Path: v2/payments/captures/:order_id
     * @param {Object} body
     * @param {any} order_id
     * @example
     * body
     * ```json
     * {
     *     "intent": "CAPTURE"
     * }
     * ```
     */
    static async purchase(body, order_id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v2/payments/captures/${order_id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * billingPlanActivate -
     *
     * Path: v1/payments/billing-plans/:plan_id
     * @param {Object} body
     * @param {any} plan_id  (example: P-7T750946YY342274V77LETVQ)
     * @example
     * body
     * ```json
     * [
     *     {
     *         "op": "replace",
     *         "path": "/",
     *         "value": {
     *             "state": "ACTIVE"
     *         }
     *     }
     * ]
     * ```
     */
    static async billingPlanActivate(body, plan_id, opts) {
      var options = {
        method: 'PATCH',
        simple: false,
        uri: hostUrl + '/' + `v1/payments/billing-plans/${plan_id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * billingPlan -
     *
     * Path: v1/payments/billing-plans
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *     "description": "Billing Agreement",
     *     "shipping_address": {
     *         "line1": "123 Main St.",
     *         "line2": "Suite #4",
     *         "city": "New York",
     *         "state": "NY",
     *         "postal_code": "12345",
     *         "country_code": "US",
     *         "recipient_name": "John Doe"
     *     },
     *     "payer": {
     *         "payment_method": "PAYPAL"
     *     },
     *     "plan": {
     *         "type": "MERCHANT_INITIATED_BILLING",
     *         "merchant_preferences": {
     *             "return_url": "https://example.com/return",
     *             "cancel_url": "https://example.com/cancel",
     *             "notify_url": "https://example.com/notify",
     *             "accepted_pymt_type": "INSTANT",
     *             "skip_shipping_address": false,
     *             "immutable_shipping_address": true
     *         }
     *     }
     * }
     * ```
     */
    static async billingPlan(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v1/payments/billing-plans`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * billingAgreementExecute -
     *
     * Path: v1/payments/billing-agreements
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *     "name": "PayPal recurring profile",
     *     "description": "PayPal payments",
     *     "start_date": "2024-07-30T08:00:00Z",
     *     "plan": {
     *         "id": "P-7T750946YY342274V77LETVQ"
     *     },
     *     "payer": {
     *         "payment_method": "paypal",
     *         "payer_info": {
     *             "email": "sb-z3kl731950278@personal.example.com"
     *         }
     *     }
     * }
     * ```
     */
    static async billingAgreementExecute(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v1/payments/billing-agreements`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * billingAgreementGet -
     *
     * Path: v1/payments/billing-agreements/:agreement_id
     * @param {Object} body
     * @param {any} agreement_id
     * @example
     * body
     * ```json
     *
     * ```
     */
    static async billingAgreementGet(body, agreement_id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `v1/payments/billing-agreements/${agreement_id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * billingAgreementToken -
     *
     * Path: v1/billing-agreements/agreement-tokens
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *     "description": "Billing Agreement",
     *     "shipping_address": {
     *         "line1": "123 Main St.",
     *         "line2": "Suite #4",
     *         "city": "New York",
     *         "state": "NY",
     *         "postal_code": "12345",
     *         "country_code": "US",
     *         "recipient_name": "John Doe"
     *     },
     *     "payer": {
     *         "payment_method": "PAYPAL",
     *         "payer_info": {
     *             "email": "sb-z3kl731950278@personal.example.com"
     *         }
     *     },
     *     "plan": {
     *         "type": "MERCHANT_INITIATED_BILLING",
     *         "merchant_preferences": {
     *             "return_url": "https://example.com/return",
     *             "cancel_url": "https://example.com/cancel",
     *             "notify_url": "https://example.com/notify",
     *             "accepted_pymt_type": "INSTANT",
     *             "skip_shipping_address": false,
     *             "immutable_shipping_address": true
     *         }
     *     }
     * }
     * ```
     */
    static async billingAgreementToken(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v1/billing-agreements/agreement-tokens`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * createBillingAgreement -
     *
     * Path: v1/billing-agreements/agreements
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *   "token_id": "BA-4DH46217K3318683J"
     * }
     * ```
     */
    static async createBillingAgreement(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v1/billing-agreements/agreements`,
        body,
        json: true,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * capture -
     *
     * Path: v2/checkout/orders/:order_id/capture
     * @param {Object} body
     * @param {any} order_id  (example: 8SJ133181C355854F)
     * @example
     * body
     * ```json
     * {
     *     "intent": "CAPTURE"
     * }
     * ```
     */
    static async capture(body, order_id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v2/checkout/orders/${order_id}/capture`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * requestBearerToken -
     *
     * Path: v1/oauth2/token
     */
    static async requestBearerToken(grant_type, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `v1/oauth2/token`,
        form: {
          grant_type,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Process {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        void:
          'billing-processor/v1/process/void/domain/:domain/gateway/:gateway/id/:id',
        purchase:
          'billing-processor/v1/process/purchase/domain/:domain/gateway/:gateway/id/:id',
        authorize:
          'billing-processor/v1/process/authorize/domain/:domain/id/:id/gateway/:gateway',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * void -
     *
     * Path: billing-processor/v1/process/void/domain/:domain/gateway/:gateway/id/:id
     * @param {Object} body
     * @param {string} domain Required. Domain. (example: traziventures.com)
     * @param {string} gateway Required. ID of the Gateway to capture on. (example: 22a55489-21e6-486b-8211-b2bc690629fn)
     * @param {string} id Required. ID of the payment. (example: e6042891-6bc3-42ea-a2fc-7f6a23de4770)
     * @param {any} gateway_overide Id of the gateway to be charged on (Optional)
     * @example
     * body
     * ```json
     * {
     *     "processorPaymentId": "", // Payment / Authorized ID | Token from the processor, that we are capturing
     *     "transaction": { // Transaction object, with capture details
     *         "id": "22a55489-21e6-486b-8211-b2bc690629fn",
     *         "token_id": "1L3HsttzcjOZ5bbA3lvX9jiPCqN",
     *         "confirmation_id": "S14X5-56969",
     *         "type": "visa",
     *         "kind": "credit_card",
     *         "card_check_digit": 1111,
     *         "status": "CAPTURED",
     *         "billing_cycle": 0,
     *         "retry_count": 0,
     *         "domain": "information.com",
     *         "product_ids": [],
     *         "subscription_ids": [
     *             "e6042891-6bc3-42ea-a2fc-7f6a23de4770"
     *         ],
     *         "coupon_ids": [],
     *         "gateway_id": "",
     *         "account_id": "b2931d64-9aea-4a9c-ace8-1c8f38dab2a7",
     *         "payment_id": null,
     *         "ip": "127.0.0.1",
     *         "country": "",
     *         "state": "",
     *         "city": "",
     *         "device_type": "desktop",
     *         "browser_type": "unknown",
     *         "browser_version": "unknown",
     *         "os": "unknown",
     *         "aid": null,
     *         "extra_tracking": null,
     *         "msrp": "1",
     *         "taxes_total": "0.07",
     *         "shipping_total": "0",
     *         "deductions_total": "0",
     *         "full_total": "1.07",
     *         "auth_amount": "4.20",
     *         "capture_amount": "1.00",
     *         "line_items": [
     *             {
     *                 "id": "3ab9a6e3-dcb5-47ab-9b45-2e69d1a562f3",
     *                 "qty": 1,
     *                 "type": "subscription"
     *             }
     *         ],
     *         "status_history": [
     *             {
     *                 "status": "PROCESSING",
     *                 "timestamp": "2023-09-21T17:15:27.900Z"
     *             },
     *             {
     *                 "status": "CAPTURED",
     *                 "timestamp": "2023-09-21T17:15:28.753Z"
     *             }
     *         ],
     *         "gateway_response_message": "Successful purchase",
     *         "gateway_response_code": null,
     *         "refunded_token": null,
     *         "refunded_at": null,
     *         "refunded_amount": null,
     *         "refunded_percentage": null,
     *         "refunded_by": null,
     *         "voided_token": null,
     *         "voided_at": null,
     *         "voided_by": null,
     *         "currency_code": "USD",
     *         "network_transaction_id": "a91b17ec83c3e7f780dd",
     *         "created_at": "2023-09-21T17:15:27.905Z",
     *         "updated_at": "2023-09-21T17:15:28.754Z",
     *         "eprofile": null,
     *         "card_bin": 411111,
     *         "version": 2
     *     }, // Transaction to capture, with capture details
     *     "extra": { // extra optional fields specific for the gateway. Should not need this but just defining
     *         "something": 23423,
     *         "needymid": "whoknows"
     *     }
     * }
     * ```
     */
    static async void(body, domain, gateway, id, gateway_overide, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/process/void/domain/${domain}/gateway/${gateway}/id/${id}`,
        qs: { gateway_overide },
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * purchase -
     *
     * Path: billing-processor/v1/process/purchase/domain/:domain/gateway/:gateway/id/:id
     * @param {Object} body
     * @param {string} domain Required. Domain. (example: traziventures.com)
     * @param {string} gateway Required. ID of the Gateway to capture on. (example: 22a55489-21e6-486b-8211-b2bc690629fn)
     * @param {string} id Required. ID of the payment. (example: e6042891-6bc3-42ea-a2fc-7f6a23de4770)
     * @param {any} gateway_overide Id of the gateway to be charged on (Optional)
     * @example
     * body
     * ```json
     * {
     *     "transaction": { // Transaction object, with capture details
     *         "id": "22a55489-21e6-486b-8211-b2bc690629fn",
     *         "token_id": "1L3HsttzcjOZ5bbA3lvX9jiPCqN",
     *         "confirmation_id": "S14X5-56969",
     *         "type": "visa",
     *         "kind": "credit_card",
     *         "card_check_digit": 1111,
     *         "status": "CAPTURED",
     *         "billing_cycle": 0,
     *         "retry_count": 0,
     *         "domain": "information.com",
     *         "product_ids": [],
     *         "subscription_ids": [
     *             "e6042891-6bc3-42ea-a2fc-7f6a23de4770"
     *         ],
     *         "coupon_ids": [],
     *         "gateway_id": "",
     *         "account_id": "b2931d64-9aea-4a9c-ace8-1c8f38dab2a7",
     *         "payment_id": null,
     *         "ip": "127.0.0.1",
     *         "country": "",
     *         "state": "",
     *         "city": "",
     *         "device_type": "desktop",
     *         "browser_type": "unknown",
     *         "browser_version": "unknown",
     *         "os": "unknown",
     *         "aid": null,
     *         "extra_tracking": null,
     *         "msrp": "1",
     *         "taxes_total": "0.07",
     *         "shipping_total": "0",
     *         "deductions_total": "0",
     *         "full_total": "1.07",
     *         "auth_amount": "4.20",
     *         "capture_amount": "1.00",
     *         "line_items": [
     *             {
     *                 "id": "3ab9a6e3-dcb5-47ab-9b45-2e69d1a562f3",
     *                 "qty": 1,
     *                 "type": "subscription"
     *             }
     *         ],
     *         "status_history": [
     *             {
     *                 "status": "PROCESSING",
     *                 "timestamp": "2023-09-21T17:15:27.900Z"
     *             },
     *             {
     *                 "status": "CAPTURED",
     *                 "timestamp": "2023-09-21T17:15:28.753Z"
     *             }
     *         ],
     *         "gateway_response_message": "Successful purchase",
     *         "gateway_response_code": null,
     *         "refunded_token": null,
     *         "refunded_at": null,
     *         "refunded_amount": null,
     *         "refunded_percentage": null,
     *         "refunded_by": null,
     *         "voided_token": null,
     *         "voided_at": null,
     *         "voided_by": null,
     *         "currency_code": "USD",
     *         "network_transaction_id": "a91b17ec83c3e7f780dd",
     *         "created_at": "2023-09-21T17:15:27.905Z",
     *         "updated_at": "2023-09-21T17:15:28.754Z",
     *         "eprofile": null,
     *         "card_bin": 411111,
     *         "version": 2
     *     }, // Transaction to capture, with capture details
     *     "extra": { // extra optional fields specific for the gateway. Should not need this but just defining
     *         "something": 23423,
     *         "needymid": "whoknows"
     *     }
     * }
     * ```
     */
    static async purchase(body, domain, gateway, id, gateway_overide, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/process/purchase/domain/${domain}/gateway/${gateway}/id/${id}`,
        qs: { gateway_overide },
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * authorize -
     *
     * Path: billing-processor/v1/process/authorize/domain/:domain/id/:id/gateway/:gateway
     * @param {Object} body
     * @param {string} domain Domain (example: traziventures.com)
     * @param {string} id payment id (example: 5f567bac-6266-4fb9-a82b-c2b6bee5d87e)
     * @param {any} gateway gateway id (example: db26cc4d-de96-43b2-becf-75aa3180b6ed)
     * @example
     * body
     * ```json
     * {
     *     "transaction": {
     *         "id": "c98f406b-1848-46a4-ba17-2d588da802c1",
     *         "token_id": "1L3HsttzcjOZ5bbA3lvX9jiPCqN",
     *         "confirmation_id": "e25cb3bcdf2ab291ef700cf9006d91f9",
     *         "type": "paypal",
     *         "kind": "paypal",
     *         "card_check_digit": null,
     *         "status": "CAPTURED",
     *         "billing_cycle": 0,
     *         "retry_count": 0,
     *         "domain": "information.com",
     *         "product_ids": [],
     *         "subscription_ids": [
     *             "a1000004-dcb5-47ab-9b45-2e69d1a562f3"
     *         ],
     *         "coupon_ids": [],
     *         "gateway_id": "d50fc1ec-f236-4f08-87a1-bc22e99f2569",
     *         "account_id": "b2931d64-9aea-4a9c-ace8-1c8f38dab2a7",
     *         "payment_id": "9526600f-82e4-4203-85c0-1aa733493ca3",
     *         "ip": "127.0.0.1",
     *         "country": "",
     *         "state": "",
     *         "city": "",
     *         "device_type": "desktop",
     *         "browser_type": "unknown",
     *         "browser_version": "unknown",
     *         "os": "unknown",
     *         "aid": null,
     *         "extra_tracking": null,
     *         "msrp": "1",
     *         "taxes_total": "0.07",
     *         "shipping_total": "0",
     *         "deductions_total": "0",
     *         "full_total": "1.07",
     *         "auth_amount": "1.00",
     *         "capture_amount": "1.00",
     *         "line_items": [
     *             {
     *                 "id": "a1000004-dcb5-47ab-9b45-2e69d1a562f3",
     *                 "qty": 1,
     *                 "type": "subscription"
     *             }
     *         ],
     *         "status_history": [
     *             {
     *                 "status": "PROCESSING",
     *                 "timestamp": "2024-06-21T17:15:27.900Z"
     *             }
     *         ],
     *         "gateway_response_message": "Successful purchase",
     *         "gateway_response_code": null,
     *         "refunded_token": null,
     *         "refunded_at": null,
     *         "refunded_amount": null,
     *         "refunded_percentage": null,
     *         "refunded_by": null,
     *         "voided_token": null,
     *         "voided_at": null,
     *         "voided_by": null,
     *         "currency_code": "USD",
     *         "network_transaction_id": "a91b17ec83c3e7f780dd",
     *         "created_at": "2024-06-21T17:15:27.900Z",
     *         "updated_at": "2024-06-21T17:15:27.900Z",
     *         "eprofile": null,
     *         "card_bin": null,
     *         "version": 2
     *     },
     *     "payment": {
     *         "id": "db26cc4d-de96-43b2-becf-75aa3180b6ed",
     *         "domain": "traziventures.com",
     *         "account_id": "39db9c4a-7b79-4d21-bdb0-58ca3d5920ae",
     *         "kind": "token",
     *         "type": "paypal",
     *         "reference_id": null,
     *         "last_reference_id": null,
     *         "name": "paypal - undefined",
     *         "preferred_payment": true,
     *         "card_number_token": "61N64772GA0757612",
     *         "card_cvc_token": null,
     *         "card_bin": null,
     *         "card_check_digit": null,
     *         "alt_identifier": null,
     *         "fingerprint": "paypalnofingerprint",
     *         "expire_month": 11,
     *         "expire_year": 2023,
     *         "expire_day": null,
     *         "country": null,
     *         "city": null,
     *         "state": null,
     *         "zip": null,
     *         "street_line_1": null,
     *         "street_line_2": null,
     *         "firstname": "MIKE",
     *         "lastname": "HUNT",
     *         "middlename": null,
     *         "ip": "UNKNOWN",
     *         "device_type": "UNKNOWN",
     *         "browser_type": "UNKNOWN",
     *         "browser_version": "UNKNOWN",
     *         "os": "UNKNOWN",
     *         "network_tokenized": false,
     *         "nt_token": null,
     *         "enabled": true,
     *         "successful_tx": 0,
     *         "failed_tx": 0,
     *         "last_transacted_gateway": null,
     *         "gateway_id": "a1000003-547e-42c8-89ff-37eb04a15c43",
     *         "created_at": "2024-06-28T19:28:36.807Z",
     *         "updated_at": "2024-06-28T19:28:39.968Z",
     *         "eprofile": null
     *     }
     * }
     * ```
     */
    static async authorize(body, domain, id, gateway, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/process/authorize/domain/${domain}/id/${id}/gateway/${gateway}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get ThirdParty() {
      return ProcessThirdParty;
    }

    static get Refund() {
      return ProcessRefund;
    }

    static get Capture() {
      return ProcessCapture;
    }
  }
  /**
   *
   */
  class ProcessThirdParty {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        activateagreement:
          'billing-processor/v1/process/thirdparty/activate/domain/:domain/type/:type/paymentId/:paymentId',
        createtoken:
          'billing-processor/v1/process/thirdparty/token/domain/:domain/type/:type',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * activateAgreement -
     *
     * Path: billing-processor/v1/process/thirdparty/activate/domain/:domain/type/:type/paymentId/:paymentId
     * @param {any} domain  (example: traziventures.com)
     * @param {any} type  (example: paypal)
     * @param {any} paymentId  (example: 4c67a91c-63b9-41f3-8fd0-e4b0936e2eba)
     */
    static async activateAgreement(domain, type, paymentId, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/process/thirdparty/activate/domain/${domain}/type/${type}/paymentId/${paymentId}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * createToken -
     *
     * Path: billing-processor/v1/process/thirdparty/token/domain/:domain/type/:type
     * @param {Object} body
     * @param {string} domain Domain (example: traziventures.com)
     * @param {any} type Third party type: paypal, google, apple (example: paypal)
     * @example
     * body
     * ```json
     * {
     *     "authorize_total": 1,
     *     "currency_code" : "USD",
     *     "redirect_url": "https://127.0.0.1/returnUrl",
     *     "first_name": "Fred",
     *     "last_name": "Ruxbin",
     *     "email" : "sb-inrug27105282@personal+1000001.example.com"
     * }
     * ```
     */
    static async createToken(body, domain, type, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/process/thirdparty/token/domain/${domain}/type/${type}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class ProcessRefund {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        partial:
          'billing-processor/v1/process/refund/partial/domain/:domain/gateway/:gateway/id/:id',
        full:
          'billing-processor/v1/process/refund/full/domain/:domain/gateway/:gateway/id/:id',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * partial -
     *
     * Path: billing-processor/v1/process/refund/partial/domain/:domain/gateway/:gateway/id/:id
     * @param {Object} body
     * @param {string} domain Required. Domain. (example: traziventures.com)
     * @param {any} gateway Required. ID of the Gateway to capture on. (example: 22a55489-21e6-486b-8211-b2bc690629fn)
     * @param {string} id Required. ID of the payment. (example: e6042891-6bc3-42ea-a2fc-7f6a23de4770)
     * @example
     * body
     * ```json
     * {
     *     "processorPaymentId": "", // Payment / Authorized ID | Token from the processor, that we are capturing
     *     "transaction": { // Transaction object, with capture details
     *         "id": "22a55489-21e6-486b-8211-b2bc690629fn",
     *         "token_id": "1L3HsttzcjOZ5bbA3lvX9jiPCqN",
     *         "confirmation_id": "S14X5-56969",
     *         "type": "visa",
     *         "kind": "credit_card",
     *         "card_check_digit": 1111,
     *         "status": "CAPTURED",
     *         "billing_cycle": 0,
     *         "retry_count": 0,
     *         "domain": "information.com",
     *         "product_ids": [],
     *         "subscription_ids": [
     *             "e6042891-6bc3-42ea-a2fc-7f6a23de4770"
     *         ],
     *         "coupon_ids": [],
     *         "gateway_id": "",
     *         "account_id": "b2931d64-9aea-4a9c-ace8-1c8f38dab2a7",
     *         "payment_id": null,
     *         "ip": "127.0.0.1",
     *         "country": "",
     *         "state": "",
     *         "city": "",
     *         "device_type": "desktop",
     *         "browser_type": "unknown",
     *         "browser_version": "unknown",
     *         "os": "unknown",
     *         "aid": null,
     *         "extra_tracking": null,
     *         "msrp": "1",
     *         "taxes_total": "0.07",
     *         "shipping_total": "0",
     *         "deductions_total": "0",
     *         "full_total": "1.07",
     *         "auth_amount": "4.20",
     *         "capture_amount": "1.00",
     *         "line_items": [
     *             {
     *                 "id": "3ab9a6e3-dcb5-47ab-9b45-2e69d1a562f3",
     *                 "qty": 1,
     *                 "type": "subscription"
     *             }
     *         ],
     *         "status_history": [
     *             {
     *                 "status": "PROCESSING",
     *                 "timestamp": "2023-09-21T17:15:27.900Z"
     *             },
     *             {
     *                 "status": "CAPTURED",
     *                 "timestamp": "2023-09-21T17:15:28.753Z"
     *             }
     *         ],
     *         "gateway_response_message": "Successful purchase",
     *         "gateway_response_code": null,
     *         "refunded_token": null,
     *         "refunded_at": null,
     *         "refunded_amount": null,
     *         "refunded_percentage": null,
     *         "refunded_by": null,
     *         "voided_token": null,
     *         "voided_at": null,
     *         "voided_by": null,
     *         "currency_code": "USD",
     *         "network_transaction_id": "a91b17ec83c3e7f780dd",
     *         "created_at": "2023-09-21T17:15:27.905Z",
     *         "updated_at": "2023-09-21T17:15:28.754Z",
     *         "eprofile": null,
     *         "card_bin": 411111,
     *         "version": 2
     *     }, // Transaction to capture, with capture details
     *     "extra": { // extra optional fields specific for the gateway. Should not need this but just defining
     *         "something": 23423,
     *         "needymid": "whoknows"
     *     }
     * }
     * ```
     */
    static async partial(body, domain, gateway, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/process/refund/partial/domain/${domain}/gateway/${gateway}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * full -
     *
     * Path: billing-processor/v1/process/refund/full/domain/:domain/gateway/:gateway/id/:id
     * @param {Object} body
     * @param {any} domain Required. Domain. (example: traziventures.com)
     * @param {any} gateway Required. ID of the Gateway to capture on. (example: 22a55489-21e6-486b-8211-b2bc690629fn)
     * @param {any} id Required. ID of the payment. (example: e6042891-6bc3-42ea-a2fc-7f6a23de4770)
     * @example
     * body
     * ```json
     * {
     *     "processorPaymentId": "", // Payment / Authorized ID | Token from the processor, that we are capturing
     *     "transaction": { // Transaction object, with capture details
     *         "id": "22a55489-21e6-486b-8211-b2bc550629fn",
     *         "token_id": "1L3HsttzcjOZ5bbA3lvX9jiPCqN",
     *         "confirmation_id": "S14X5-56909",
     *         "type": "visa",
     *         "kind": "credit_card",
     *         "card_check_digit": 1111,
     *         "status": "CAPTURED",
     *         "billing_cycle": 0,
     *         "retry_count": 0,
     *         "domain": "information.com",
     *         "product_ids": [],
     *         "subscription_ids": [
     *             "e6042891-6bc3-42ea-a2fc-7f6a23de4770"
     *         ],
     *         "coupon_ids": [],
     *         "gateway_id": "",
     *         "account_id": "b2931d64-9aea-4a9c-ace8-1c8f38dab2a7",
     *         "payment_id": null,
     *         "ip": "127.0.0.1",
     *         "country": "",
     *         "state": "",
     *         "city": "",
     *         "device_type": "desktop",
     *         "browser_type": "unknown",
     *         "browser_version": "unknown",
     *         "os": "unknown",
     *         "aid": null,
     *         "extra_tracking": null,
     *         "msrp": "1",
     *         "taxes_total": "0.07",
     *         "shipping_total": "0",
     *         "deductions_total": "0",
     *         "full_total": "1.07",
     *         "auth_amount": "1.00",
     *         "capture_amount": "1.00",
     *         "line_items": [
     *             {
     *                 "id": "3ab9a6e3-dcb5-47ab-9b45-2e69d1a562f3",
     *                 "qty": 1,
     *                 "type": "subscription"
     *             }
     *         ],
     *         "status_history": [
     *             {
     *                 "status": "PROCESSING",
     *                 "timestamp": "2023-09-21T17:15:27.900Z"
     *             },
     *             {
     *                 "status": "AUTHORIZED",
     *                 "timestamp": "2023-09-21T17:15:28.753Z"
     *             }
     *         ],
     *         "gateway_response_message": "Successful purchase",
     *         "gateway_response_code": null,
     *         "refunded_token": null,
     *         "refunded_at": null,
     *         "refunded_amount": null,
     *         "refunded_percentage": null,
     *         "refunded_by": null,
     *         "voided_token": null,
     *         "voided_at": null,
     *         "voided_by": null,
     *         "currency_code": "USD",
     *         "network_transaction_id": "a91b17ec83c3e7f780dd",
     *         "created_at": "2023-09-21T17:15:27.905Z",
     *         "updated_at": "2023-09-21T17:15:28.754Z",
     *         "eprofile": null,
     *         "card_bin": 411111,
     *         "version": 1
     *     }, // Transaction to capture, with capture details
     *     "extra": { // extra optional fields specific for the gateway. Should not need this but just defining
     *         "something": 23423,
     *         "needymid": "whoknows"
     *     }
     * }
     * ```
     */
    static async full(body, domain, gateway, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/process/refund/full/domain/${domain}/gateway/${gateway}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class ProcessCapture {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        partial:
          'billing-processor/v1/process/capture/partial/domain/:domain/gateway/:gateway/id/:id',
        full:
          'billing-processor/v1/process/capture/full/domain/:domain/gateway/:gateway/id/:id',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * partial -
     *
     * Path: billing-processor/v1/process/capture/partial/domain/:domain/gateway/:gateway/id/:id
     * @param {Object} body
     * @param {string} domain Required. Domain. (example: traziventures.com)
     * @param {any} gateway Required. ID of the Gateway to capture on. (example: 22a55489-21e6-486b-8211-b2bc690629fn)
     * @param {string} id Required. ID of the payment. (example: e6042891-6bc3-42ea-a2fc-7f6a23de4770)
     * @example
     * body
     * ```json
     * {
     *     "processorPaymentId": "", // Payment / Authorized ID | Token from the processor, that we are capturing
     *     "transaction": { // Transaction object, with capture details
     *         "id": "22a55489-21e6-486b-8211-b2bc690629fn",
     *         "token_id": "1L3HsttzcjOZ5bbA3lvX9jiPCqN",
     *         "confirmation_id": "S14X5-56969",
     *         "type": "visa",
     *         "kind": "credit_card",
     *         "card_check_digit": 1111,
     *         "status": "CAPTURED",
     *         "billing_cycle": 0,
     *         "retry_count": 0,
     *         "domain": "information.com",
     *         "product_ids": [],
     *         "subscription_ids": [
     *             "e6042891-6bc3-42ea-a2fc-7f6a23de4770"
     *         ],
     *         "coupon_ids": [],
     *         "gateway_id": "",
     *         "account_id": "b2931d64-9aea-4a9c-ace8-1c8f38dab2a7",
     *         "payment_id": null,
     *         "ip": "127.0.0.1",
     *         "country": "",
     *         "state": "",
     *         "city": "",
     *         "device_type": "desktop",
     *         "browser_type": "unknown",
     *         "browser_version": "unknown",
     *         "os": "unknown",
     *         "aid": null,
     *         "extra_tracking": null,
     *         "msrp": "1",
     *         "taxes_total": "0.07",
     *         "shipping_total": "0",
     *         "deductions_total": "0",
     *         "full_total": "1.07",
     *         "auth_amount": "4.20",
     *         "capture_amount": "1.00",
     *         "line_items": [
     *             {
     *                 "id": "3ab9a6e3-dcb5-47ab-9b45-2e69d1a562f3",
     *                 "qty": 1,
     *                 "type": "subscription"
     *             }
     *         ],
     *         "status_history": [
     *             {
     *                 "status": "PROCESSING",
     *                 "timestamp": "2023-09-21T17:15:27.900Z"
     *             },
     *             {
     *                 "status": "CAPTURED",
     *                 "timestamp": "2023-09-21T17:15:28.753Z"
     *             }
     *         ],
     *         "gateway_response_message": "Successful purchase",
     *         "gateway_response_code": null,
     *         "refunded_token": null,
     *         "refunded_at": null,
     *         "refunded_amount": null,
     *         "refunded_percentage": null,
     *         "refunded_by": null,
     *         "voided_token": null,
     *         "voided_at": null,
     *         "voided_by": null,
     *         "currency_code": "USD",
     *         "network_transaction_id": "a91b17ec83c3e7f780dd",
     *         "created_at": "2023-09-21T17:15:27.905Z",
     *         "updated_at": "2023-09-21T17:15:28.754Z",
     *         "eprofile": null,
     *         "card_bin": 411111,
     *         "version": 2
     *     }, // Transaction to capture, with capture details
     *     "extra": { // extra optional fields specific for the gateway. Should not need this but just defining
     *         "something": 23423,
     *         "needymid": "whoknows"
     *     }
     * }
     * ```
     */
    static async partial(body, domain, gateway, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/process/capture/partial/domain/${domain}/gateway/${gateway}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * full -
     *
     * Path: billing-processor/v1/process/capture/full/domain/:domain/gateway/:gateway/id/:id
     * @param {Object} body
     * @param {any} domain Required. Domain. (example: traziventures.com)
     * @param {any} gateway Required. ID of the Gateway to capture on. (example: 22a55489-21e6-486b-8211-b2bc690629fn)
     * @param {any} id Required. ID of the payment. (example: e6042891-6bc3-42ea-a2fc-7f6a23de4770)
     * @example
     * body
     * ```json
     * {
     *     "processorPaymentId": "", // Payment / Authorized ID | Token from the processor, that we are capturing
     *     "transaction": { // Transaction object, with capture details
     *         "id": "22a55489-21e6-486b-8211-b2bc550629fn",
     *         "token_id": "1L3HsttzcjOZ5bbA3lvX9jiPCqN",
     *         "confirmation_id": "S14X5-56909",
     *         "type": "visa",
     *         "kind": "credit_card",
     *         "card_check_digit": 1111,
     *         "status": "CAPTURED",
     *         "billing_cycle": 0,
     *         "retry_count": 0,
     *         "domain": "information.com",
     *         "product_ids": [],
     *         "subscription_ids": [
     *             "e6042891-6bc3-42ea-a2fc-7f6a23de4770"
     *         ],
     *         "coupon_ids": [],
     *         "gateway_id": "",
     *         "account_id": "b2931d64-9aea-4a9c-ace8-1c8f38dab2a7",
     *         "payment_id": null,
     *         "ip": "127.0.0.1",
     *         "country": "",
     *         "state": "",
     *         "city": "",
     *         "device_type": "desktop",
     *         "browser_type": "unknown",
     *         "browser_version": "unknown",
     *         "os": "unknown",
     *         "aid": null,
     *         "extra_tracking": null,
     *         "msrp": "1",
     *         "taxes_total": "0.07",
     *         "shipping_total": "0",
     *         "deductions_total": "0",
     *         "full_total": "1.07",
     *         "auth_amount": "1.00",
     *         "capture_amount": "1.00",
     *         "line_items": [
     *             {
     *                 "id": "3ab9a6e3-dcb5-47ab-9b45-2e69d1a562f3",
     *                 "qty": 1,
     *                 "type": "subscription"
     *             }
     *         ],
     *         "status_history": [
     *             {
     *                 "status": "PROCESSING",
     *                 "timestamp": "2023-09-21T17:15:27.900Z"
     *             },
     *             {
     *                 "status": "AUTHORIZED",
     *                 "timestamp": "2023-09-21T17:15:28.753Z"
     *             }
     *         ],
     *         "gateway_response_message": "Successful purchase",
     *         "gateway_response_code": null,
     *         "refunded_token": null,
     *         "refunded_at": null,
     *         "refunded_amount": null,
     *         "refunded_percentage": null,
     *         "refunded_by": null,
     *         "voided_token": null,
     *         "voided_at": null,
     *         "voided_by": null,
     *         "currency_code": "USD",
     *         "network_transaction_id": "a91b17ec83c3e7f780dd",
     *         "created_at": "2023-09-21T17:15:27.905Z",
     *         "updated_at": "2023-09-21T17:15:28.754Z",
     *         "eprofile": null,
     *         "card_bin": 411111,
     *         "version": 1
     *     }, // Transaction to capture, with capture details
     *     "extra": { // extra optional fields specific for the gateway. Should not need this but just defining
     *         "something": 23423,
     *         "needymid": "whoknows"
     *     }
     * }
     * ```
     */
    static async full(body, domain, gateway, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/process/capture/full/domain/${domain}/gateway/${gateway}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Payment {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        rebalance:
          'billing-processor/v1/payment/rebalance/domain/:domain/id/:id',
        editbyid: 'billing-processor/v1/payment/edit/domain/:domain/id/:id',
        removebyid: 'billing-processor/v1/payment/remove/domain/:domain/id/:id',
        editbyaccount:
          'billing-processor/v1/payment/edit/domain/:domain/account/:account/id/:id',
        setpreferred:
          'billing-processor/v1/payment/preferred/domain/:domain/account/:account/id/:id',
        removebyaccount:
          'billing-processor/v1/payment/remove/domain/:domain/account/:account/id/:id',
        verify:
          'billing-processor/v1/payment/verify/domain/:domain/account/:account/id/:id',
        attach:
          'billing-processor/v1/payment/attach/domain/:domain/account/:account/id/:id',
        setup: 'billing-processor/v1/payment/setup/domain/:domain',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * rebalance -
     *
     * Path: billing-processor/v1/payment/rebalance/domain/:domain/id/:id
     * @param {any} domain [Required] Domain of the payment to rebalance
     * @param {any} id [Required] ID of the payment to rebalance
     */
    static async rebalance(domain, id, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/rebalance/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * editById -
     *
     * Path: billing-processor/v1/payment/edit/domain/:domain/id/:id
     * @param {Object} body
     * @param {any} domain Required. Domain of the payment to edit
     * @param {any} id Required. ID of the payment to edit
     * @example
     * body
     * ```json
     * {
     *     "expire_month": "11"
     * }
     * ```
     */
    static async editById(body, domain, id, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/edit/domain/${domain}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * removeById -
     *
     * Path: billing-processor/v1/payment/remove/domain/:domain/id/:id
     * @param {any} domain
     * @param {any} id
     */
    static async removeById(domain, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/remove/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * editByAccount -
     *
     * Path: billing-processor/v1/payment/edit/domain/:domain/account/:account/id/:id
     * @param {Object} body
     * @param {any} domain
     * @param {any} account
     * @param {any} id
     * @example
     * body
     * ```json
     *
     * ```
     */
    static async editByAccount(body, domain, account, id, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/edit/domain/${domain}/account/${account}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * setPreferred -
     *
     * Path: billing-processor/v1/payment/preferred/domain/:domain/account/:account/id/:id
     * @param {any} domain Filter by this domain.
     * @param {any} account Account Id
     * @param {any} id Payment Id
     */
    static async setPreferred(domain, account, id, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/preferred/domain/${domain}/account/${account}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * removeByAccount -
     *
     * Path: billing-processor/v1/payment/remove/domain/:domain/account/:account/id/:id
     * @param {any} domain Filter by this domain.
     * @param {any} account Account ID
     * @param {any} id Payment ID
     */
    static async removeByAccount(domain, account, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/remove/domain/${domain}/account/${account}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * verify -
     *
     * Path: billing-processor/v1/payment/verify/domain/:domain/account/:account/id/:id
     * @param {any} domain
     * @param {any} account
     * @param {any} id
     */
    static async verify(domain, account, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/verify/domain/${domain}/account/${account}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * attach -
     *
     * Path: billing-processor/v1/payment/attach/domain/:domain/account/:account/id/:id
     * @param {any} domain
     * @param {any} account
     * @param {any} id
     */
    static async attach(domain, account, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/attach/domain/${domain}/account/${account}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * setup -
     *
     * Path: billing-processor/v1/payment/setup/domain/:domain
     * @param {Object} body
     * @param {any} domain  (example: information.com)
     * @example
     * body
     * ```json
     * {
     *     "card_cvc": "123",
     *     "card_number": "4111111111111111",
     *     "email": "benjamin.jones+cerb.checkout.dunning.11@information.com",
     *     "expire_month": "12",
     *     "expire_year": "56",
     *     "exp_day": "24",
     *     "card_bin": "411111",
     *     "firstname": "Philyyyyyyyyy",
     *     "card_check_digit": "1111",
     *     "lastname": "Waynker",
     *     "zipcode": "83201",
     *     "street_line_1": "123 Yes Ave.",
     *     "city": "Orlando",
     *     "state": "FL",
     *     "middlename": "Willy"
     * }
     * ```
     */
    static async setup(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl + '/' + `billing-processor/v1/payment/setup/domain/${domain}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get Count() {
      return PaymentCount;
    }

    static get List() {
      return PaymentList;
    }
  }
  /**
   *
   */
  class PaymentCount {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        byaccount:
          'billing-processor/v1/payment/count/domain/:domain/account/:account',
        bydomain: 'billing-processor/v1/payment/count/domain/:domain',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byAccount -
     *
     * Path: billing-processor/v1/payment/count/domain/:domain/account/:account
     * @param {any} domain
     * @param {any} account
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, expire_year = 2024)
     * @param {any} skip Optional. Number of rows to skip before counting.
     */
    static async byAccount(domain, account, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/count/domain/${domain}/account/${account}`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byDomain -
     *
     * Path: billing-processor/v1/payment/count/domain/:domain
     * @param {any} domain
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, expire_year = 2024)
     * @param {any} skip Optional. Number of rows to skip before counting.
     */
    static async byDomain(domain, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing-processor/v1/payment/count/domain/${domain}`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class PaymentList {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        byid: 'billing-processor/v1/payment/list/domain/:domain/id/:id',
        byaccount:
          'billing-processor/v1/payment/list/domain/:domain/account/:account',
        bydomain: 'billing-processor/v1/payment/list/domain/:domain',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byId -
     *
     * Path: billing-processor/v1/payment/list/domain/:domain/id/:id
     * @param {any} domain Filter by this domain.
     * @param {any} id
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/list/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * byAccount - 
  *
  * Path: billing-processor/v1/payment/list/domain/:domain/account/:account
  * @param {any} domain Filter by this domain. (example: traziventures.com)
  * @param {any} account Account ID (example: 69443915-464a-42fd-9b98-e8dc7933cfc1)
  * @param {any} limit Optional: Limit results count. 
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} 
  * @param {any} skip Optional. Number of rows to skip. 
  * @param {any} preferred Optional. If true will pull the preferred payment for the account. (example: true)
  */
    static async byAccount(
      domain,
      account,
      limit,
      props,
      skip,
      preferred,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/payment/list/domain/${domain}/account/${account}`,
        qs: { limit, props, skip, preferred },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * byDomain - 
  *
  * Path: billing-processor/v1/payment/list/domain/:domain
  * @param {any} domain  (example: asdfsg4325345634563465)
  * @param {any} limit Optional: Limit results count. 
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} 
  * @param {any} skip Optional. Number of rows to skip before counting. 
  * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, expire_year = 2024) 
  * @param {any} sort Optional. Column name to sort Payments 
  * @param {any} sortDesc Optional. Boolean value to determine sort direction 
  */
    static async byDomain(
      domain,
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing-processor/v1/payment/list/domain/${domain}`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Gateway {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        byid: 'billing-processor/v1/gateway/domain/:domain/id/:id',
        edit: 'billing-processor/v1/gateway/edit/domain/:domain/id/:id',
        remove: 'billing-processor/v1/gateway/remove/domain/:domain/id/:id',
        add: 'billing-processor/v1/gateway/add/domain/:domain/type/:type',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byId -
     *
     * Path: billing-processor/v1/gateway/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id  (example: 80f2df73-16d0-4c13-b5c2-3309e3a45d8a)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/gateway/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * edit -
     *
     * Path: billing-processor/v1/gateway/edit/domain/:domain/id/:id
     * @param {Object} body
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id Id of gateway to be edited (example: d3f2a910-4c0e-4d34-a2ac-e4a0f1e03338)
     * @example
     * body
     * ```json
     * {
     *     "name": "Testy Marmoset",
     *     "description": "Wanted a finger monkey but this will do",
     *     "domain": "traziventures.com",
     *     "pan": null,
     *     "enabled": true,
     *     "unwinding": false,
     *     "loadbalance_percent": "0.3",
     *     "soft_monthly_money_cap": "100000",
     *     "soft_monthly_transactions_cap": 20000,
     *     "acquiring_bank": "Marmoset National Bank LB2",
     *     "provider": "Rich Marmosets",
     *     "displayed_descriptor": "TRZ*Test002",
     *     "midigator_id": "mid_12345678902",
     *     "settings": {
     *       "bearer_token": "",
     *       "allowed_card_types": ["visa", "mastercard","marmacard"],
     *       "visa_network_tokens": true,
     *       "mastercard_network_tokens": true,
     *       "fail_every_x_transaction": 0,
     *       "delay_response_time": 0,
     *       "dummy_ui_select": ["one", "two", "three"],
     *       "dummy_ui_multi_select": ["one", "two", "three"],
     *       "dummy_ui_text": null,
     *       "dummy_ui_number": 1,
     *       "dummy_ui_checkbox": true,
     *       "dummy_ui_date": null,
     *       "dummy_ui_password": null,
     *       "dummy_ui_percentage": null
     *     },
     *     "details": {},
     *     "authentication": { "secrect_information": "secret", "other_secret_information": "other_secret" }
     *   }
     * ```
     */
    static async edit(body, domain, id, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/gateway/edit/domain/${domain}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * remove -
     *
     * Path: billing-processor/v1/gateway/remove/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id Id of Gateway to be removed (example: d3f2a910-4c0e-4d34-a2ac-e4a0f1e03338)
     */
    static async remove(domain, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/gateway/remove/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add -
     *
     * Path: billing-processor/v1/gateway/add/domain/:domain/type/:type
     * @param {Object} body
     * @param {any} domain  (example: traziventures.com)
     * @param {any} type paypal,checkout,payarc (example: paypal)
     * @example
     * body
     * ```json
     * {
     *     "name": "Test Gateway 1006",
     *     "description": "LB Gateway 1006",
     *     "domain": "traziventures.com",
     *     "pan": null,
     *     "enabled": true,
     *     "unwinding": false,
     *     "loadbalance_percent": "0.3",
     *     "soft_monthly_money_cap": "3548",
     *     "soft_monthly_transactions_cap": 450,
     *     "acquiring_bank": "National Bank LB1006",
     *     "provider": "Rich Finger Monkeys",
     *     "displayed_descriptor": "TRZ*Test1006",
     *     "midigator_id": "mid_1234561006",
     *     "settings": {
     *       "bearer_token": "",
     *       "allowed_card_types": ["visa", "mastercard", "amex"],
     *       "visa_network_tokens": true,
     *       "mastercard_network_tokens": true,
     *       "fail_every_x_transaction": 0,
     *       "delay_response_time": 0,
     *       "dummy_ui_select": ["one", "two", "three"],
     *       "dummy_ui_multi_select": ["one", "two", "three"],
     *       "dummy_ui_text": null,
     *       "dummy_ui_number": 1,
     *       "dummy_ui_checkbox": true,
     *       "dummy_ui_date": null,
     *       "dummy_ui_password": null,
     *       "dummy_ui_percentage": null
     *     },
     *     "details": {
     *
     *           "url": {
     *             "display_name": "Url",
     *             "type": "string",
     *             "category": "general",
     *             "value": "https://trazidev.com/"
     *           },
     *           "auth_duration_limit": {
     *             "display_name": "Suggested Authorization Duration Limit",
     *             "type": "string",
     *             "category": "processing",
     *             "value": "10 Days"
     *           },
     *           "duplicate_transaction_limit": {
     *             "display_name": "Duplicate Transaction Limit",
     *             "type": "string",
     *             "category": "processing",
     *             "value": "1 Minute"
     *           }
     *     },
     *     "authentication": { "secrect_information": "secret", "other_secret_information": "other_secret" }
     *   }
     * ```
     */
    static async add(body, domain, type, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/gateway/add/domain/${domain}/type/${type}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get Count() {
      return GatewayCount;
    }

    static get List() {
      return GatewayList;
    }

    static get Caps() {
      return GatewayCaps;
    }
  }
  /**
   *
   */
  class GatewayCount {
    constructor() {}
    static get _postgenClassUrls() {
      return { bydomain: 'billing-processor/v1/gateway/count/domain/:domain' };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byDomain -
     *
     * Path: billing-processor/v1/gateway/count/domain/:domain
     * @param {any} domain  (example: traziventures.com)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. enabled=true) (example: enabled = true)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     */
    static async byDomain(domain, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing-processor/v1/gateway/count/domain/${domain}`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class GatewayList {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        bydomain: 'billing-processor/v1/gateway/list/domain/:domain',
        possible: 'billing-processor/v1/gateway/list/possible',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
  * byDomain - 
  *
  * Path: billing-processor/v1/gateway/list/domain/:domain
  * @param {any} domain  (example: traziventures.com)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each onject. 
(example: name,enabled, will return objects with the following structure:
{
"name": "test block for getting",
"enabled": true
} (example: name,enabled)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} params Optional. Comma separated SQL predicates (e.g. enabled=true) (example: id = d3f2a910-4c0e-4d34-a2ac-e4a0f1e03338)
  * @param {any} sort Optional. Column name to sort (example: created_at)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async byDomain(
      domain,
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing-processor/v1/gateway/list/domain/${domain}`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * possible -
     *
     * Path: billing-processor/v1/gateway/list/possible
     */
    static async possible(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/v1/gateway/list/possible`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class GatewayCaps {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        byid: 'billing-processor/v1/gateway/caps/id/:id',
        countlist: 'billing-processor/v1/gateway/caps/list/count',
        list: 'billing-processor/v1/gateway/caps/list',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byId -
     *
     * Path: billing-processor/v1/gateway/caps/id/:id
     * @param {any} id Id of Caps record (example: 4405f779-134b-4dbb-8753-c0b83ed2457d)
     */
    static async byId(id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/v1/gateway/caps/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countList -
     *
     * Path: billing-processor/v1/gateway/caps/list/count
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, current_money = 0) (example: current_transactions=0, current_money = 0)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
     */
    static async countList(params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/v1/gateway/caps/list/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - 
  *
  * Path: billing-processor/v1/gateway/caps/list
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each onject. 
(example: name,enabled, will return objects with the following structure:
{
"name": "test block for getting",
"enabled": true
} (example: month,year)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, current_money = 0) (example: current_transactions=1234, current_money = 50)
  * @param {any} sort Optional. Column name to sort Caps (example: current_money)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async list(limit, props, skip, params, sort, sortDesc, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/v1/gateway/caps/list`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Blocked {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        deletebyidnodomain: 'billing-processor/v1/blocked/id/:id',
        deletebyid: 'billing-processor/v1/blocked/domain/:domain/id/:id',
        editnodomain: 'billing-processor/v1/blocked/id/:id',
        edit: 'billing-processor/v1/blocked/domain/:domain/id/:id',
        addnodomain: 'billing-processor/v1/blocked/add',
        add: 'billing-processor/v1/blocked/domain/:domain/add',
        byidnodomain: 'billing-processor/v1/blocked/id/:id',
        byid: 'billing-processor/v1/blocked/domain/:domain/id/:id',
        countlistnodomain: 'billing-processor/v1/blocked/list/count',
        countlist: 'billing-processor/v1/blocked/domain/:domain/list/count',
        listnodomain: 'billing-processor/v1/blocked/list',
        list: 'billing-processor/v1/blocked/domain/:domain/list',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * deleteByIdNoDomain - Deletes a blocked payment on the domain and matching the ID of request parameters.
     *
     * Path: billing-processor/v1/blocked/id/:id
     * @param {any} id ID of blocked payment to delete. (example: 72476cd4-a0e2-41bd-b78f-99e7fd3f9333)
     */
    static async deleteByIdNoDomain(id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/v1/blocked/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * deleteById - Deletes a blocked payment on the domain and matching the ID of request parameters.
     *
     * Path: billing-processor/v1/blocked/domain/:domain/id/:id
     * @param {any} domain Domain of blocked payment to remove. (example: traziventures.com)
     * @param {any} id ID of blocked payment to delete. (example: 72476cd4-a0e2-41bd-b78f-99e7fd3f9333)
     */
    static async deleteById(domain, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/blocked/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * editNoDomain - Edits an existing blocked payment on the domain in request parameter.
     *
     * Path: billing-processor/v1/blocked/id/:id
     * @param {Object} body
     * @param {any} id ID for blocked card to edit (example: b569372a-44da-4695-86fe-67128f8d9feb)
     * @example
     * body
     * ```json
     * {
     *     "name": "update block",
     *     "type": "credit_card",
     *     "data": "4111111111",
     *     "enabled": true,
     *     "extra": {}
     * }
     * ```
     */
    static async editNoDomain(body, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/v1/blocked/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * edit - Edits an existing blocked payment on the domain in request parameter.
     *
     * Path: billing-processor/v1/blocked/domain/:domain/id/:id
     * @param {Object} body
     * @param {any} domain Domain of blocked to edit (example: traziventures.com)
     * @param {any} id ID for blocked card to edit (example: a4603c94-8864-42a0-941b-8de466ed424b)
     * @example
     * body
     * ```json
     * {
     *     "name": "update block",
     *     "type": "credit_card",
     *     "data": "4111111111",
     *     "enabled": true,
     *     "extra": {}
     * }
     * ```
     */
    static async edit(body, domain, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/blocked/domain/${domain}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * addNoDomain - Adds blocked payment method under domain that is sent in with request params.
     *
     * Path: billing-processor/v1/blocked/add
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *     "name": "test block",
     *     "type": "credit_card",
     *     "data": "abcd12345",
     *     "enabled": true,
     *     "extra": {}
     * }
     * ```
     */
    static async addNoDomain(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/v1/blocked/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add - Adds blocked payment method under domain that is sent in with request params.
     *
     * Path: billing-processor/v1/blocked/domain/:domain/add
     * @param {Object} body
     * @param {any} domain Domain to add blocked payment method under. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *     "name": "test block",
     *     "type": "credit_card",
     *     "data": "abcd12345",
     *     "enabled": true,
     *     "extra": {}
     * }
     * ```
     */
    static async add(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl + '/' + `billing-processor/v1/blocked/domain/${domain}/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byIdNoDomain - Returns object of blocked payment ID matching domain and ID searched by.
     *
     * Path: billing-processor/v1/blocked/id/:id
     * @param {any} id Required. ID to search for the desired blocked payment by. (example: 5287a2af-1e42-4ec7-9410-6987e8020a6a)
     */
    static async byIdNoDomain(id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/v1/blocked/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - Returns object of blocked payment ID matching domain and ID searched by.
     *
     * Path: billing-processor/v1/blocked/domain/:domain/id/:id
     * @param {any} domain Requires. Domain to filter by. (example: traziventures.com)
     * @param {any} id Required. ID to search for the desired blocked payment by. (example: 5287a2af-1e42-4ec7-9410-6987e8020a6a)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/blocked/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countListNoDomain - Returns a number that is the count of all blocked payments
     *
     * Path: billing-processor/v1/blocked/list/count
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: type=credit_card, enabled = true)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     */
    static async countListNoDomain(params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/v1/blocked/list/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countList - Returns a number that is the count of all blocked payments
     *
     * Path: billing-processor/v1/blocked/domain/:domain/list/count
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: type=credit_card, enabled = true)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     */
    static async countList(domain, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing-processor/v1/blocked/domain/${domain}/list/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * listNoDomain - Returns an array of objects where each object is a blocked BIN
  *
  * Path: billing-processor/v1/blocked/list
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each  object. 

(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: name,enabled)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} params Optional. Exact match filtering. Comma separated SQL predicates (e.g. account_id=1337e, expire_year = 2024) (example: type=credit_card, enabled = true)
  * @param {any} sort Optional. Column name to sort Blocked (example: created_at)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async listNoDomain(
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing-processor/v1/blocked/list`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - Returns an array of objects where each object is a blocked BIN
  *
  * Path: billing-processor/v1/blocked/domain/:domain/list
  * @param {any} domain Required. Filter by this domain. (example: traziventures.com)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each  object. 

(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: name,enabled)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} params Optional. Exact match filtering. Comma separated SQL predicates (e.g. account_id=1337e, expire_year = 2024) (example: type=credit_card, enabled = true)
  * @param {any} sort Optional. Column name to sort Blocked (example: created_at)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async list(
      domain,
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing-processor/v1/blocked/domain/${domain}/list`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }

  return {
    BillingProcessor,
    Transcripts,
    Checkoutdotcom,
    Vgs,
    VgsNetworktokens,
    Paypal,
    Process,
    ProcessThirdParty,
    ProcessRefund,
    ProcessCapture,
    Payment,
    PaymentCount,
    PaymentList,
    Gateway,
    GatewayCount,
    GatewayList,
    GatewayCaps,
    Blocked,
  };
}
module.exports = SDK;

